import { StandingOffer } from "@/features/standing-offer";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/standing-offer/$standingOfferId")({
  component: StandingOfferId
});

function StandingOfferId() {
  const { standingOfferId } = Route.useParams();

  return <StandingOffer standingOfferId={standingOfferId} />;
}
